import { getPaxAccessToken } from 'helper/grab-id-auth-helper';
import { SERVICE_TYPE_FIELDS } from 'constants/booking-constants';
import { createActionType, createFetchAction } from './action-helper';
import endpoints from './booking-endpoints';

export const CLEAN_ALL = 'CLEAN_ALL';
export const CREATE_ORDER = createActionType('CREATE_ORDER');
export const GET_QUOTES = createActionType('GET_QUOTES');
export const GET_QUOTES_WITH_PROMO = createActionType('GET_QUOTES_WITH_PROMO');
export const GET_QUOTES_WITHOUT_REDUX = createActionType(
  'GET_QUOTES_WITHOUT_REDUX',
);
export const GET_ADDRESS_TRANSLATION = createActionType(
  'GET_ADDRESS_TRANSLATION',
);
export const GET_ADDRESS_SEARCH = createActionType('GET_ADDRESS_SEARCH');
export const GET_PAYMENT_METHODS = createActionType('GET_PAYMENT_METHODS');
export const FETCH_SERVICE_TYPES = createActionType('FETCH_SERVICE_TYPES');

export const cleanAllAction = () => ({
  type: CLEAN_ALL,
});

export const createOrderAction = (orders, callback) =>
  createFetchAction(
    CREATE_ORDER,
    endpoints.getCreateOrderV2Ept(),
    {
      method: 'POST',
      body: orders,
    },
    callback,
  );

export const getQuotesAction = (orders, callback) =>
  createFetchAction(
    GET_QUOTES,
    endpoints.getQuotesEpt(),
    { method: 'POST', body: orders },
    callback,
  );

export const getQuotesWithPromoAction = (orders, callback) =>
  createFetchAction(
    GET_QUOTES_WITH_PROMO,
    endpoints.getQuotesEpt(),
    { method: 'POST', body: orders },
    callback,
  );

export const getQuotesWithoutReduxAction = (orders, callback) =>
  createFetchAction(
    GET_QUOTES_WITHOUT_REDUX,
    endpoints.getQuotesEpt(),
    { method: 'POST', body: orders },
    callback,
  );

export const getAddressTranslationAction = (param, callback) =>
  createFetchAction(
    GET_ADDRESS_TRANSLATION,
    endpoints.getAddressTranslationEpt(param),
    { method: 'GET' },
    callback,
  );
export const getAddressSearchAction = (param, callback) =>
  createFetchAction(
    GET_ADDRESS_SEARCH,
    endpoints.getAddressSearchEpt(param),
    { method: 'GET' },
    callback,
  );

export const getPaymentMethodsAction = (
  companyID,
  coundtryCode,
  groupID,
  callback,
) =>
  createFetchAction(
    GET_PAYMENT_METHODS,
    endpoints.getPaymentDetailsEpt(companyID, coundtryCode, groupID),
    { method: 'GET' },
    callback,
  );

export const fetchServiceTypesAction = (param, callback) =>
  createFetchAction(
    FETCH_SERVICE_TYPES,
    endpoints.fetchServiceTypesEpt(),
    { method: 'POST', body: param },
    callback,
  );

// ----------------------V2------------------------

export const BOOK_AGAIN = 'BOOK_AGAIN';
export const bookAgainAction = order => ({
  type: BOOK_AGAIN,
  payload: order,
});

export const UPDATE_ORDER = 'UPDATE_ORDER';
export const updateOrderAction = order => ({
  type: UPDATE_ORDER,
  payload: order,
});

// use for update name, phone, cod which does not trigger any follow action
export const UPDATE_ORDER_SHALLOW = 'UPDATE_ORDER_SHALLOW';
export const updateOrderShallowAction = order => ({
  type: UPDATE_ORDER_SHALLOW,
  payload: order,
});

export const UPDATE_BULK_ORDER = 'UPDATE_BULK_ORDER';
export const updateBulkOrderAction = payload => ({
  type: UPDATE_BULK_ORDER,
  payload, // { index, order, orders }
});

export const UPDATE_BULK_ORDER_SHALLOW = 'UPDATE_BULK_ORDER_SHALLOW';
export const updateBulkOrderShallowAction = payload => ({
  type: UPDATE_BULK_ORDER_SHALLOW,
  payload, // { index, order, orders }
});

export const FETCH_SERVICE_TYPES_V2 = createActionType(
  'FETCH_SERVICE_TYPES_V2',
);
export const fetchServiceTypesActionV2 = (cityID, companyID, callback) => {
  const params = {
    request: {
      queryParams: {
        IDS: [0], // ignore this
        includeInactive: false,
        cityID: Number(cityID),
      },
      fields: SERVICE_TYPE_FIELDS,
      companyID,
    },
  };

  return createFetchAction(
    FETCH_SERVICE_TYPES_V2,
    endpoints.fetchServiceTypesEpt(),
    { method: 'POST', body: params },
    callback,
  );
};

export const PAX_FETCH_SERVICE_TYPES = createActionType(
  'PAX_FETCH_SERVICE_TYPES',
);
export const paxFetchServiceTypesAction = (cityID, callback = null) => {
  const params = {
    input: {
      fields: SERVICE_TYPE_FIELDS,
      queryParams: {
        IDS: [0],
        cityID: Number(cityID),
        includeInactive: false,
      },
    },
  };

  return createFetchAction(
    PAX_FETCH_SERVICE_TYPES,
    endpoints.paxFetchServiceTypesEpt(),
    { method: 'POST', body: params },
    callback,
    { type: 'Authorization', value: `Bearer ${getPaxAccessToken()}` },
  );
};

export const FETCH_QUOTE_V2 = createActionType('FETCH_QUOTE_V2');
export const fetchQuoteActionV2 = (orders, callback) =>
  createFetchAction(
    FETCH_QUOTE_V2,
    endpoints.getQuotesEpt(),
    { method: 'POST', body: orders },
    callback,
  );

export const CREATE_ORDER_V2 = createActionType('CREATE_ORDER_V2');
export const createOrderActionV2 = (orders, callback) =>
  createFetchAction(
    CREATE_ORDER_V2,
    endpoints.getCreateOrderV2Ept(),
    {
      method: 'POST',
      body: orders,
    },
    callback,
  );

export const FETCH_ALL_PAYMENT_METHODS = 'FETCH_ALL_PAYMENT_METHODS';
export const getAllPaymentMethodsV2 = (company, group) => ({
  type: FETCH_ALL_PAYMENT_METHODS,
  payload: { company, group },
});

export const FETCH_ALL_PAYMENT_METHODS_SUCCESS =
  'FETCH_ALL_PAYMENT_METHODS_SUCCESS';
export const getAllPaymentMethodsSuccessV2 = result => ({
  type: FETCH_ALL_PAYMENT_METHODS_SUCCESS,
  payload: result,
});

export const PAX_FETCH_ALL_PAYMENT_METHODS = 'PAX_FETCH_ALL_PAYMENT_METHODS';
export const getAllPaxPaymentMethodsV2 = countryCode => ({
  type: PAX_FETCH_ALL_PAYMENT_METHODS,
  payload: { countryCode },
});

export const PAX_FETCH_ALL_PAYMENT_METHODS_SUCCESS =
  'PAX_FETCH_ALL_PAYMENT_METHODS_SUCCESS';
export const getAllPaxPaymentMethodsSuccessV2 = result => ({
  type: PAX_FETCH_ALL_PAYMENT_METHODS_SUCCESS,
  payload: result,
});

export const CLEAR_ORDERS_ACTION_V2 = 'CLEAR_ORDERS_ACTION_V2';
export const clearOrdersActionV2 = () => ({
  type: CLEAR_ORDERS_ACTION_V2,
});

export const PROCESS_BULK_UPLOAD_DATA_V2 = 'PROCESS_BULK_UPLOAD_DATA_V2';
export const processBulkUploadDataActionV2 = payload => ({
  type: PROCESS_BULK_UPLOAD_DATA_V2,
  payload,
});

export const PROCESS_BULK_UPLOAD_DATA_COMPLETE_V2 =
  'PROCESS_BULK_UPLOAD_DATA_COMPLETE_V2';
export const processBulkUploadDataCompleteActionV2 = (
  payload,
  thanosExternalIntimateLoginResponse,
) => ({
  type: PROCESS_BULK_UPLOAD_DATA_COMPLETE_V2,
  payload,
  thanosExternalIntimateLoginResponse, // optional
});

export const SET_PAYMENT_METHODS = 'SET_PAYMENT_METHODS';
export const setPaymentMethodsAction = paymentsPayload => ({
  type: SET_PAYMENT_METHODS,
  payload: paymentsPayload,
});
